//
//
//
//
//
//

import utils from '@/utils'
import userApi from '@/api/user'
import teacherApi from '@/api/teacher'
import { Const } from '@/consts'
import { MessageBox } from 'mint-ui'
export default {
  name: 'App',
  data() {
    return {
      timer: '',
      value: 0,
      websock: null,
      techerId: 0,
      teacherInfo: {
        id: 0,
        teacherid: 0,
        schoolid: 0,
        schoolname: '',
        username: '',
        approvalstatus: 'NOTSUBMIT',
        usertype: 'STUDENT'
      }
    }
  },
  methods: {
    get() {
      this.value++
      /* console.log(this.value)
      console.log(document.domain)
      console.log('登录信息')
      console.log(utils.getUserToken())
      console.log('websock状态' + utils.get('USER_TYPE'))
      console.log(this.websock) */
      /* USER_TYPE - TOURIST 游客
        USER_TYPE - TEACHER 教师
        USER_TYPE - USER 用户 */
      //console.log(this.$route.query)
      if (window.location.href.toLowerCase().indexOf('gelaisen') !== -1) {
         utils.save('ceshi', 'OK')
      }
      //更新时隐藏
     utils.save('ceshi', 'OK')

      if (utils.getUserToken()) {
        if (
          !(navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
            && navigator.userAgent.toLowerCase().indexOf('wechatdevtools') === -1
            && navigator.userAgent.toLowerCase().indexOf('windowswechat') === -1)
          && utils.get('ceshi') !== 'OK'
        ) {
          MessageBox.confirm('登录出错！请在微信内打开', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'info'
          }).then(action => {
            // alert("微信退出，清空缓存")
            utils.clearUserInfo()
            utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
            utils.save('AUTOREPLACE', true)// 自动刷新-刷新WebSoket
          }).catch(() => {
            alert("微信页面异常，清空缓存")
            utils.clearUserInfo()
            utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
            utils.save('AUTOREPLACE', true)// 自动刷新-刷新WebSoket
          })
        }
        // if ((this.websock !== null || this.websock.readyState !== 1) && this.websochetStatus === 0) {
        //  教师用户必须建立连接
        if (utils.get('USER_TYPE') === 'TEACHER' && (this.websock == null || this.websock.readyState !== 1)) {
          this.getTeacherInfo()
        } else if (utils.get('USER_TYPE') === 'USER') {
          if (this.websock !== null && this.websock.readyState === 1) {
            this.websocketClose()
          }
          /* if (this.value % 24 === 0) {
            this.getTeacherInfo()
          } */
        } else if (utils.get('USER_TYPE') === 'TEACHER') {
          if (this.value % 10 === 0 && this.websock.readyState === 1) {
            // let actions = {'type': 'ping', 'techerId': this.techerId}
            this.websocketsend(JSON.stringify({ 'type': 'ping', 'techerId': this.techerId }))
          }
        }
      } else {
        //只能在手机微信打开
        if (!
          (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
            && navigator.userAgent.toLowerCase().indexOf('wechatdevtools') === -1
            && navigator.userAgent.toLowerCase().indexOf('windowswechat') === -1)
          && utils.get('ceshi') !== 'OK'
        ) {
          var opened = window.open('https://ww.sdjtip.com/weixinssehfkghn87ydh.html', '_self')
          opened.opener = null
          //opened.close()
        }
      }
    },
    // 显示通知、注意事项、待完成工作
    getUserMessage() {
      teacherApi.getUserMessage().then((resp) => {
        const result = resp[Const.RESP_RESULT] || {}
        if (result.isLive) {
          const usermessage = result.usermessage
          MessageBox.confirm(usermessage.message, usermessage.title, {
            confirmButtonText: '确定',
            closeOnClickModal: false,
            type: 'info'
          }).then(action => {
            if (usermessage.wapurlOk !== '') {
              this.$router.replace(usermessage.wapurlOk)
            }
          }).catch(() => {
            if (usermessage.wapurlNo !== '') {
              this.$router.replace(usermessage.wapurlNo)
            }
          })



        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')

        }
      })
    },
    // 获取（教师）成员类型-并根据返回值建立WebSocket连接
    getTeacherInfo() {
      teacherApi.getTeacherInfo().then((resp) => {
        const result = resp[Const.RESP_RESULT] || {}
        if (result.usertype === 'TEACHER-111111') {
          this.teacherInfo = {
            id: result.id,
            teacherid: result.teacherid,
            schoolid: result.schoolid,
            schoolname: result.schoolname,
            username: result.username,
            approvalstatus: result.approvalstatus,
            usertype: result.usertype
          }
          utils.save('TEACHER_INFO', this.teacherInfo)
          console.log('教师账户建立WebSocket')
          if (typeof (WebSocket) === 'undefined') {
            alert('你的浏览器不支持视频通话，请更换。')
          } else {
            console.log('恭喜：您的浏览器支持WebSocket')
            utils.save('USER_TYPE', 'TEACHER')// 用户类型-教师
            this.techerId = result.teacherid
            this.initWebSocket()
          }
        } else {
          utils.save('USER_TYPE', 'USER')// 用户类型-学员
          if (this.websock !== null && this.websock.readyState === 1) { // 如果有连接就断开
            this.websocketClose()
          }
        }
      }).catch((resp) => {
        if (resp.statusCode === '200') {
          // eslint-disable-next-line no-undef
          Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
          if (this.websock !== null && this.websock.readyState === 1) { // 如果有连接就断开
            this.websocketClose()
          }
        }
      })
    },
    initWebSocket() { // 初始化weosocket
      let httpp = '';
      const ishttps = 'https:' === document.location.protocol ? true : false;
      if (ishttps) {
        httpp = 'wss://';
      } else {
        httpp = 'ws://';
      }
      //端口号
      window.location.port
      let webport = '';
      window.location.port === 80 ? webport = '' : webport = ':' + window.location.port;
      const wsuri = httpp + document.domain + webport + '/ws/asset'
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen() { // 连接建立之后执行send方法发送数据
      // let actions = {'type': 'first', 'techerId': this.techerId}
      this.websocketsend(JSON.stringify({ 'type': 'first', 'techerId': this.techerId }))
      // this.websocketsend(this.techerId)
    },
    websocketonerror() { // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage(e) { // 数据接收
      const redata = JSON.parse(e.data)
      console.log('服务器返回信息：' + redata.live)
      console.log('服务器返回信息：' + redata.url)
      console.log(e)
      console.log(e.data)
      if (redata.live) {
        utils.save('LIVEURL', redata.url)
        this.$router.replace('/personal/teacher/videoCall')
        // this.liveIn()
      } else {
        utils.save('LIVEURL', 'no')
        if (this.$route.path === '/personal/teacher/videoCall') {
          this.$router.replace('/personal/teacher/teacher')
        }
      }
    },
    websocketsend(Data) { // 数据发送
      this.websock.send(Data)
    },
    websocketclose(e) { // 关闭
      console.log('断开连接', e)
    },
    websocketClose() { // 关闭
      this.websock.close()
      console.log('自动断开websocket连接')
    },
    liveIn() {
      MessageBox.confirm('人社局发起直播监管，请接受。', '直播请求', {
        confirmButtonText: '确定',
        closeOnClickModal: false,
        type: 'info'
      }).then(action => {
        this.$router.replace('/personal/teacher/videoCall')
      }).catch(() => {

      })
    }
  },

  mounted() {


    if (utils.get('LIVEURL') == null) {
      utils.save('LIVEURL', 'no')
    }
    if (utils.getUserToken()) {
      this.getTeacherInfo()
      this.getUserMessage()
    }
    this.timer = setInterval(this.get, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  destroyed() {
    //alert("系统关闭")
    if(this.websock==null){
      this.websock.close() // 离开路由之后断开websocket连接
    }
    utils.clear('USER_TYPE')// 清除用户类型信息
  }

}



// WEBPACK FOOTER //
// ./src/App.vue